import React from "react";
import styles from "./loader.scss";

const Loader = () => {
    return (
        <div className={styles.icon_loader}>
            <div className={styles.shimmer_box}>
                <div className={styles.box_inside}>
                    <div className={styles.heading}>
                        <span className={styles.visual}></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Loader;